import * as S from './styles';
import { Slider, Slide, CarouselProviderProps, SliderProps, SlideProps, ButtonBackProps, ButtonNextProps, DotGroupProps, DotGroup } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

function WDCarouselProvider({ children, ...props }: CarouselProviderProps) {
  return (
    <S.CarouselWrapper {...props}>
      {children}
    </S.CarouselWrapper >
  );
}

function WDCarouselSlider({ children, ...props }: SliderProps) {
  return (
    <Slider {...props}>
      {children}
    </Slider>
  );
}

function WDCarouselSlide({ children, ...props }: SlideProps) {
  return (
    <Slide {...props}>
      {children}
    </Slide>
  );
}

function WdCarouselButtonBack({ children, ...props }: ButtonBackProps) {
  return (
    <S.ButtonBackWrapper {...props}>
      {children}
    </S.ButtonBackWrapper>
  );
}

function WdCarouselButtonNext({ children, ...props }: ButtonNextProps) {
  return (
    <S.ButtonNextWrapper {...props}>
      {children}
    </S.ButtonNextWrapper>
  );
}

function WdCarouselDotGroup({ ...props }: DotGroupProps) {
  return (
    <S.DotWrapper>
      <DotGroup className="dot-group" {...props} />
    </S.DotWrapper>
  );
}

export { WDCarouselProvider, WDCarouselSlider, WDCarouselSlide, WdCarouselButtonBack, WdCarouselButtonNext, WdCarouselDotGroup };